// import "./style/dashboard_style.css";
import MenuLayoutComponent from "../../components/menu/menu_layout_comp";
import ChatComponent from "../chat/chat_comp";
import GalleryPage from "../gallery/gallery_page";
import ProfilePage from "../profile/profile_page";
import DiscoverPage from "../discover/discover_page";

const DashboardPage = () => {
  return MenuLayoutComponent({
    chatContent: ChatComponent(),
    galleryContent: DiscoverPage(),
    settingsContent: ProfilePage(),
    // <div class="dashboard-container  m-2 border-round-2xl">
    // <UnsubsComp />
    // </div>
  });
};

export default DashboardPage;
